import { IEntity, IRemoteFileInfo, IUploadedFileInfo } from 'interfaces-lib';
import { WorkflowMessage } from 'interfaces-lib';
import { MessageNotificationService } from 'message-notification-service-lib';
import { UtilsService } from 'utils-service-lib';
import { WorkflowTask } from 'workflow-task-service-lib';
import { runtimeEnvironment } from '../../environments/environment';
import { FileListControllerService } from '../services/file-list.controller.service';
import { EntitySelection } from '../template-list-view/template-workflow-types/templateworkflowcontext';

export class SaveToEntityTask extends WorkflowTask {
  constructor(
    private restoreKey: string,
    private outputFormats: string[],
    private entity: IEntity,
    private entitySelection: EntitySelection,
    private fileListControllerService: FileListControllerService,
    private messageNotificationService: MessageNotificationService,
    private utilsService: UtilsService,
    private editorFileInfo: IRemoteFileInfo | undefined,
    private outputFilename: string,
    private saveSuccessCallback?: (entity: IEntity, entitySelection: EntitySelection, result: IUploadedFileInfo[]) => void
  ) {
    super('SAVE_TO_ENTITY');
  }

  override getStartParams(): any {
    return {
      RESTORE_STATE: {
        key: this.restoreKey,
      },
      OUTPUT_FORMATS: this.outputFormats,
      EDITOR_FILE: this.editorFileInfo,
      OUTPUT_FILENAME_FINAL: this.outputFilename,
      SOURCE_APPLICATION: "DOC_CLIENT",
    };
  }

  override workflowStartSuccess() {
    super.workflowStartSuccess();
    this.messageNotificationService.info('Saving...');
  }

  override receive(message: WorkflowMessage): boolean {
    if (message.type === 'ErrorEvent') {
      this.messageNotificationService.error('Failed to save document.', message.message);
      return true;
    }

    if (message.type === 'SavedToEntity') {
      this.messageNotificationService.success(
        `Document saved to ${UtilsService.capitaliseFirstLetter(runtimeEnvironment.origin.namespace)}`
      );
      this.fileListControllerService.refresh(this.entity);
      if (this.saveSuccessCallback) {
        this.saveSuccessCallback(this.entity, this.entitySelection, message.message);
      }
      return true;
    }

    console.debug(`Message '${message.type}' not handled.`);

    return false;
  }
}
